import styled from 'styled-components'

export const HighlightedText = styled.strong<{ color?: string }>`
  color: ${({ color, theme }) => color || theme.colors.primary};
`
